// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-pro-drop-down[data-v-4c936209] .action {\n  margin-right: 8px;\n}\n.ant-pro-drop-down[data-v-4c936209] .ant-dropdown-menu-item {\n  min-width: 160px;\n}\n", ""]);
// Exports
module.exports = exports;
